import Page from 'src/apipages/upload/videos/index';

export default Page;
